/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Overview_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Whenever a body of work needs its own context or audience, for example one project per department, client, or recurring task. Separate projects keep instruct..." |
*
* @param {Uno_Edu_Project_Overview_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_overview_chip1_answer = /** @type {((inputs?: Uno_Edu_Project_Overview_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Overview_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Immer wenn ein Arbeitsbereich eigenen Kontext oder ein eigenes Publikum benötigt, etwa ein Projekt pro Abteilung, Kunde oder wiederkehrender Aufgabe. Getrennte Projekte verhindern, dass Anweisungen und Wissen ineinander überlaufen.")
	return /** @type {LocalizedString} */ ("Whenever a body of work needs its own context or audience, for example one project per department, client, or recurring task. Separate projects keep instructions and knowledge from bleeding into each other.")
});